import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { CrmOrganizationsService } from 'src/app/parameters/crm-organizations/crm-organizations.service';
import { CrmSynchronizationConversationComponent } from 'src/app/parameters/crm-organizations/crm-synchronization-conversation/crm-synchronization-conversation.component';
import { CrmOrganizationsComponent } from './crm-organizations.component';

downgradedAngularModule
  .directive('angularCrmOrganizations', downgradeComponent({ component: CrmOrganizationsComponent }))
  .directive('angularCrmSynchronizationConversation', downgradeComponent({ component: CrmSynchronizationConversationComponent }))
  .factory('AngularCrmOrganizationsService', downgradeInjectable(CrmOrganizationsService))
  ;

